export default class Footer{
	constructor(node){
		this.node = node;
	}

	updateContent(content){
		this.node.innerHTML = content;
	}
}
